import {
  DeceasedReport,
  ReportResultStatus,
  ReportStatus,
  ReportType,
} from '../models/report.model';
import { CeidgStatus, MaritalPropertyCommunity } from '../models/ceidg.model';

export const extendedReportExample: Extract<
  DeceasedReport,
  { type: ReportType.EXTENDED }
> = {
  status: ReportStatus.PROCESSED,
  type: ReportType.EXTENDED,
  reportNumber: '2025/00000/ROZSZERZONY-PRZYKLAD',
  order: {
    orderNumber: '2025/00000/PRZYKŁAD',
    updatedAt: new Date(),
    createdAt: new Date(),
    client: {
      name: 'Jan',
      lastName: 'Kowalski',
      email: 'jan.kowalski@mspadek.pl'
    }
  },
  updatedAt: new Date(),
  createdAt: new Date(),
  databaseStatusOn: new Date(),
  deceased: {
    name: 'Jan',
    lastName: 'Kowalski',
    peselNumber: '00000000000',
    dateOfDeath: new Date('2025-12-31'),
    taxId: '000000000',
  },
  lookup: {
    ceidg: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    crbr: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    krz: {
      status: ReportStatus.SKIPPED,
      timestamp: new Date(),
    },
    msig: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    sudop: {
      status: ReportStatus.SKIPPED,
      timestamp: new Date(),
    },
    vatWl: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    krs: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
  },
  result: {
    ceidg: {
      status: ReportResultStatus.EXISTS,
      files: null,
      data: [
        {
          taxId: '1234567890',
          ceidgId: 'CEIDG-001',
          name: 'Kowalski Consulting',
          businessyAddress: {
            street: 'Marszalkowska',
            buildingNumber: '10',
            localNumber: '5',
            postalCode: '00-001',
            city: 'Warszawa',
          },
          owner: {
            firstName: 'Jan',
            lastName: 'Kowalski',
            taxId: '1234567890',
          },
          citizenships: [
            {
              countryCode: 'PL',
              countryName: 'Polska',
            },
          ],
          startDate: new Date('2018-01-10'),
          suspensionDate: null,
          terminationDate: null,
          removalDate: null,
          resumptionDate: null,
          status: CeidgStatus.ACTIVE,
          statusNumber: 1,
          maritalPropertyCommunity: MaritalPropertyCommunity.YES,
          partnership: [],
        },
      ],
    },
    krs: {
      propertyRights: {
        status: ReportResultStatus.SKIPPED,
        data: null,
        files: null,
      },
      companyAuthorities: {
        status: ReportResultStatus.NOT_EXISTS,
        data: [],
        files: null,
      },
    },
    crbr: {
      status: ReportResultStatus.EXISTS,
      files: null,
      data: [
        {
          crbrId: 'CRBR-01',
          regDate: '2023-01-15',
          name: 'ABC Sp. z o.o.',
          nip: '1111111111',
          krs: '0000123456',
          address: 'ul. Prosta 1, 00-001 Warszawa',
        },
      ],
    },
    krz: {
      status: ReportResultStatus.SKIPPED,
      files: null,
      data: null,
    },
    msig: {
      status: ReportResultStatus.NOT_EXISTS,
      files: null,
      data: [],
    },
    vatWl: {
      status: ReportResultStatus.EXISTS,
      files: null,
      data: {
        name: 'Kowalski Consulting',
        nip: '1234567890',
        statusVat: 'Czynny',
        accountNumbers: ['11 1111 1111 1111 1111 1111 1111'],
        registrationLegalDate: '2018-01-10',
      },
    },
    sudop: {
      status: ReportResultStatus.SKIPPED,
      files: null,
      data: null,
    },
  },
};
